import React from "react";
import "../StoragePages.scss";
import { Page } from "components/core/Page";
import { StorageHeader } from "components/storages/Header";
import {
	BorderLine,
	Description,
	Heading,
	LastSearchBar,
	ListPoint,
	SubHeading
} from "components/storages/Common";
import { CAR_STORAGE_DATA } from "components/storages/ContentData/CarStorageData";
import Container from "components/core/Page/Container";
import { ScrollToTop } from "components/core/ScrollToTop";
import { Paragraph } from "components/core/Typography";
import { useSelector } from "react-redux";
import { PAGE_SUB_TYPES } from "@sparefoot/tracking-events";
import usePageViewTracking from "hooks/tracking/usePageViewTracking";

function CarStoragePage() {
	const baseUrl = useSelector((state) => state?.app?.baseUrl);
	usePageViewTracking(PAGE_SUB_TYPES.CAR_LANDING);

	return (
		<Page
			className="storage-page"
			pageType={PAGE_SUB_TYPES.CAR_LANDING}
			title="Car Storage - Rental Guide & Facility Search | Storage.com"
			description="Find car storage solutions for every need on Storage.com. 
			Compare hundreds of options near you and reserve a unit online in minutes."
			canonical={`${baseUrl}/car-storage/`}
		>
			<Container>
				<StorageHeader
					heading="Find Car Storage Near You!"
					searchIn="car"
					level="1"
				/>
				<div className="all-sections">
					{CAR_STORAGE_DATA?.map((item, index) => (
						<>
							<Heading
								content={item.heading}
								level={item.level}
							/>
							<Description desc={item.description} />
							{item.description2 && (
								<Description desc={item.description2} />
							)}
							{item.subHeadings &&
								item.subHeadings.map((subHeading) => (
									<>
										{item.heading === "Car Storage FAQs" ? (
											<Paragraph
												size="xlarge"
												weight="bold"
											>
												{subHeading.title}
											</Paragraph>
										) : (
											<SubHeading
												title={subHeading.title}
												level="4"
											/>
										)}

										{subHeading.descLink ? (
											<Description
												descLink={subHeading.descLink}
											/>
										) : (
											<>
												<Description
													desc={subHeading.desc}
												/>

												{subHeading.desc2 && (
													<>
														<br />
														<Description
															desc={
																subHeading.desc2
															}
														/>
													</>
												)}
											</>
										)}
									</>
								))}
							<ul>
								{item.points &&
									item.points.map((point) => (
										<ListPoint
											title={point.title}
											desc={point.desc}
											bulletPoints={false}
										/>
									))}
							</ul>
							{item.description3 && (
								<Description desc={item.description3} />
							)}
							{index !== CAR_STORAGE_DATA.length - 1 && (
								<BorderLine />
							)}
						</>
					))}
					<LastSearchBar />
				</div>
			</Container>
			<ScrollToTop />
		</Page>
	);
}

export default CarStoragePage;
